// extracted by mini-css-extract-plugin
export default {"container":"S9sN9","header":"AEPCu","link":"KZjoX"};